import utils from '../utils';

export default function getPartialDuration(event, index, splitTimeString = '00:00') {
  const eventDtstart = utils.toDateObject(event.dtstart);
  const eventDtstartString = utils.toDateString(event.dtstart);
  const eventDtend = utils.toDateObject(event.dtend);

  let splitDate = utils.dateFromHours(splitTimeString, eventDtstartString);
  while (splitDate <= eventDtstart) {
    splitDate = utils.addDays(splitDate, 1);
  }

  return (
    [
      eventDtend > splitDate ? splitDate - eventDtstart : eventDtend - eventDtstart,
      eventDtend > splitDate ? eventDtend - splitDate : 0,
    ][index] /
    1000 /
    60 /
    60
  );
}
